import type { EmailTemplate } from '../types';
import { EmailTemplateEventType } from '../types';

export const EVENT_TYPES_TO_SHOW_WHEN_AUTO_REMINDERS_FLAG_IS_DISABLED = [EmailTemplateEventType.DOCUMENT_SHARE];

export const filterEmailTemplatesByEventTypeVisibility = (
  emailTemplates: EmailTemplate[],
  showAllEventTypes?: boolean
): EmailTemplate[] => {
  if (showAllEventTypes) return emailTemplates;

  return emailTemplates.filter(
    (template) => template.eventType && EVENT_TYPES_TO_SHOW_WHEN_AUTO_REMINDERS_FLAG_IS_DISABLED.includes(template.eventType)
  );
};

export const groupEmailTemplatesByEventType = (
  emailTemplates: EmailTemplate[],
  showAllEventTypes?: boolean
): Record<string, EmailTemplate[]> =>
  filterEmailTemplatesByEventTypeVisibility(emailTemplates, showAllEventTypes).reduce<Record<string, EmailTemplate[]>>((acc, template) => {
    if (template?.eventType && !acc[template.eventType]) acc[template.eventType] = [];

    if (template?.eventType && template?.versionSegment) {
      acc[template.eventType].push(template);
    }

    return acc;
  }, {} as Record<string, EmailTemplate[]>);

export const getEmailTemplateEventTypeLabelKey = (eventType: string) =>
  `settings.email_templates.template_id_type_labels.${String(eventType).replace(/-/g, '_')?.trim()?.toLowerCase()}`;
